import React from 'react'
import { HugeiconsIcon } from '@hugeicons/react'
import { NoteIcon } from '@hugeicons/core-free-icons'
import { FieldTypeOptions } from '../../../RightSideBar/information/FieldTypeSelect'

// Notes isn't in FieldTypeOptions (users can't add it), but every user starts with one.
const NOTES_OPTION = { label: 'Notes', type: 'notes', icon: <HugeiconsIcon icon={NoteIcon} size={12} /> }

export const getFieldType = (type) => (
  type === 'notes' ? NOTES_OPTION : FieldTypeOptions.find(option => option.type === type)
) || { label: type, type, icon: null }

// Sidebar-created items have no title yet, so fall back to the type label.
export const getFieldName = (item) => (item.input && item.input.title) || item.label
